import { Component } from '@theme/component';
import { sectionRenderer } from '@theme/section-renderer';
import { RecentlyViewed } from '@theme/recently-viewed-products';
import { requestIdleCallback } from '@theme/utilities';

/**
 * Renders the standalone "recently viewed products" home page section.
 *
 * The section renders an empty, hidden shell on a normal page load (the
 * server has no way to know which products a visitor looked at). On connect,
 * this component checks localStorage for recently viewed product ids and, if
 * any exist, re-fetches this same section against a search query for those
 * ids so the server can resolve and render the real product cards, then
 * morphs the result into place. Stays hidden for visitors with no history.
 */
class RecentlyViewedSectionComponent extends Component {
  connectedCallback() {
    super.connectedCallback();

    const sectionId = this.dataset.sectionId;
    const viewedProducts = RecentlyViewed.getProducts();
    if (!sectionId || viewedProducts.length === 0) return;

    const url = new URL(Theme.routes.search_url, location.origin);
    url.searchParams.set('q', viewedProducts.map((/** @type {string} */ id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');

    requestIdleCallback(() => {
      sectionRenderer.renderSection(sectionId, { url, cache: false }).catch(() => {});
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    const sectionId = this.dataset.sectionId;
    if (sectionId) sectionRenderer.abortRender(sectionId);
  }
}

if (!customElements.get('recently-viewed-section-component')) {
  customElements.define('recently-viewed-section-component', RecentlyViewedSectionComponent);
}
